import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { authAPI } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';
import './MyQRCode.css';

const MyQRCode = () => {
  const { t } = useLanguage();
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [qrSize, setQrSize] = useState(260);

  useEffect(() => {
    fetchQRCode();
  }, []);

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth;
      if (width < 360) {
        setQrSize(Math.min(width - 80, 220));
      } else if (width < 480) {
        setQrSize(240);
      } else {
        setQrSize(280);
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const fetchQRCode = async () => {
    try {
      const response = await authAPI.getQRCode();
      if (!response.data?.qr_code_token) {
        setError(t('qr.missing'));
        return;
      }
      setQrData(response.data);
    } catch (err) {
      console.error('Failed to fetch QR code:', err);
      setError(err.response?.data?.error || t('qr.loadFail'));
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  if (error || !qrData) {
    return (
      <div className="qr-code-page">
        <h1>{t('qr.title')}</h1>
        <div className="alert alert-error">{error || t('qr.loadFail')}</div>
      </div>
    );
  }

  return (
    <div className="qr-code-page">
      <h1>{t('qr.title')}</h1>
      <div className="qr-card card text-center">
        <h2>{qrData.chinese_name}</h2>
        <p className="member-number">{t('qr.number')}{qrData.member_number}</p>

        <div className="qr-code-container">
          <QRCodeSVG
            value={qrData.qr_code_token}
            size={qrSize}
            level="H"
            includeMargin={true}
            className="qr-code-svg"
          />
        </div>

        <div className="qr-instructions">
          <h3>{t('qr.share')}</h3>
          <p>
            <a href={`https://wa.me/?text=${encodeURIComponent(`${t('qr.shareText')} ${window.location.origin}/card/${qrData.qr_code_token}`)}`}>{t('qr.whatsapp')}</a>
          </p>
          <p>
            <a href={`mailto:?subject=${encodeURIComponent(t('qr.mailSubject'))}&body=${encodeURIComponent(`${window.location.origin}/card/${qrData.qr_code_token}`)}`}>{t('qr.email')}</a>
          </p>
          <button type="button" className="btn btn-secondary" onClick={() => navigator.clipboard.writeText(`${window.location.origin}/card/${qrData.qr_code_token}`)}>{t('qr.copy')}</button>
          <p>{t('qr.wallet')}</p>
        </div>

        <div className="qr-instructions">
          <h3>{t('qr.help')}</h3>
          <ul>
            <li>{t('qr.help1')}</li>
            <li>{t('qr.help2')}</li>
            <li>{t('qr.help3')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MyQRCode;
